module.exports = __webpack_public_path__ + "img/acc.993e0265.jpg";